import * as yup from 'yup';

const currentYear = new Date().getFullYear();
const minAllowedYear = currentYear - 25;
export const eighteenYearsAgo = new Date();
eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - 18);

export const driverSchema = yup.object().shape({
  // Driver information
  firstName: yup
    .string()
    .required('El nombre es requerido')
    .max(25, 'El nombre debe tener menos de 25 caracteres'),
  lastName: yup
    .string()
    .required('El apellido es requerido')
    .max(25, 'El apellido debe tener menos de 25 caracteres'),
  dni: yup
    .string()
    .required('El DNI es requerido')
    .length(8, 'El DNI debe tener 8 caracteres')
    .matches(/^[0-9]+$/, 'El DNI debe contener solo números'),
  phone: yup
    .string()
    .required('El teléfono es requerido')
    .length(10, 'El teléfono debe tener 10 caracteres')
    .matches(/^[0-9]+$/, 'El teléfono debe contener solo números'),
  state: yup.string().required('La provincia es requerida'),
  city: yup.string().required('La localidad es requerida'),
  email: yup
    .string()
    .email('Email inválido')
    .required('El email es requerido')
    .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'El email debe ser válido'),
  birthDate: yup
    .date()
    .required('La fecha de nacimiento es requerida')
    .max(eighteenYearsAgo, 'Debes ser mayor de 18 años para registrarte')
    .typeError('Fecha de nacimiento inválida'),
  gender: yup.string().required('El género es requerido'),

  // Vehicle information
  licensePlate: yup.string().required('La patente es requerida'),
  vehicleType: yup.string().required('El tipo de vehículo es requerido'),
  brand: yup.string().required('La marca es requerida'),
  model: yup.string().required('El modelo es requerido'),
  color: yup.string().required('El color es requerido'),
  year: yup
    .number()
    .typeError('El año debe ser un número')
    .min(minAllowedYear, `El año debe ser mayor o igual a ${minAllowedYear}`)
    .max(currentYear, `El año debe ser menor o igual a ${currentYear}`)
    .required('El año es requerido'),

  // Files
  profilePhoto: yup
    .array()
    .min(1, 'La foto de perfil es requerida')
    .required('La foto de perfil es requerida'),
  dniFrontPhoto: yup
    .array()
    .min(1, 'La foto frontal del DNI es requerida')
    .required('La foto frontal del DNI es requerida'),
  dniBackPhoto: yup
    .array()
    .min(1, 'La foto trasera del DNI es requerida')
    .required('La foto trasera del DNI es requerida'),
  licenseFrontPhoto: yup
    .array()
    .min(1, 'La foto frontal de la licencia es requerida')
    .required('La foto frontal de la licencia es requerida'),
  licenseBackPhoto: yup
    .array()
    .min(1, 'La foto trasera de la licencia es requerida')
    .required('La foto trasera de la licencia es requerida'),
  vehicleRegistrationFrontPhoto: yup
    .array()
    .min(1, 'La foto frontal de la cédula es requerida')
    .required('La foto frontal de la cédula es requerida'),
  vehicleRegistrationBackPhoto: yup
    .array()
    .min(1, 'La foto trasera de la cédula es requerida')
    .required('La foto trasera de la cédula es requerida'),
});

export type DriverFormData = yup.InferType<typeof driverSchema>;
export type RawDriverFormData = yup.InferType<typeof driverSchema>;
